import { RBACSchema } from './rbac-permissions';
import { RBACPermissions } from './rbac-types';
import { User } from '../../shared/types/generated';

export const checkUserRole = (permission?: RBACPermissions | null, user?: User | null): boolean => {
  const roles = user?.roles_on_users?.map((roles_on_user) => roles_on_user?.role?.name);
  if (!permission) return true;

  console.log({ roles, user });

  return !!RBACSchema.find(
    (schema) =>
      roles?.includes(schema.Role) && permission && schema.Permissions.includes(permission),
  );
};
